import React, { useState, useContext, useMemo } from 'react';

import PropTypes from 'prop-types';

const Context = React.createContext();

export function useFloatingFilterBarContext() {
  return useContext(Context);
}

export default function FloatingFilterBarContext({ children }) {
  const [isFilterBarVisible, setFilterBarVisible] = useState(false);

  const value = useMemo(
    () => ({ isFilterBarVisible, setFilterBarVisible }),
    [isFilterBarVisible]
  );
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

FloatingFilterBarContext.propTypes = {
  children: PropTypes.node,
};
